import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconLetterC = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.757 4.757A6 6 0 0 1 11 3h2a6 6 0 0 1 6 6 1 1 0 1 1-2 0 4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h2a4 4 0 0 0 4-4 1 1 0 1 1 2 0 6 6 0 0 1-6 6h-2a6 6 0 0 1-6-6V9a6 6 0 0 1 1.757-4.243"
            clipRule="evenodd"
        />
    </svg>
);
